import React, { useRef } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
// components
import Button from "../../../components/Elements/Button.js";
import Input from "../../../components/Elements/Input.js";
import Checkbox from "../../../components/Elements/Checkbox.js";

// actions
import { loginUser } from "../../../actions/users";

const CardLogin = ({
  title,
  inputs = [],
  button = {},
  checkbox,
  forgotPassword = {},
  createAccount = {},
  signIn = {},
  error,
}) => {
  const dispatch = useDispatch();

  const refs = {};
  refs["email"] = useRef("");
  refs["password"] = useRef("");

  const handleLogin = (e) => {
    e.preventDefault();
    const email = refs["email"].current.value;
    const password = refs["password"].current.value;
    dispatch(loginUser(email, password));
  };

  return (
    <>
      <div className="relative flex flex-col w-full mb-2 shadow-lg rounded-lg bg-white">
        <div className="mb-0 px-6 py-6">
          <div className="text-center mb-3">
            <h6 className="text-blueGray-500 text-sm font-bold">{title}</h6>
          </div>
          {error ? (
            <div className="text-center mb-3">
              <h6 className="text-red-500 text-sm font-bold">{error}</h6>
            </div>
          ) : null}
          <form>
            {inputs.map((prop, key) => {
              return (
                <div key={key} className="relative w-full">
                  <label className="block uppercase text-blueGray-500 text-xs font-bold mb-2 ml-1">
                    {prop.label}
                  </label>
                  <Input ref={refs[prop.label.toLowerCase()]} {...prop.input} />
                </div>
              );
            })}
            <div className="mt-2 inline-block">
              <Checkbox {...checkbox} />
            </div>

            <div className="text-center mt-5">
              <Button {...button} onClick={handleLogin} />
            </div>
          </form>
        </div>
      </div>
      {Object.keys(forgotPassword).length === 0 &&
      Object.keys(createAccount).length === 0 &&
      Object.keys(signIn) === 0 ? null : (
        <div className="flex flex-wrap relative">
          <div className="w-1/2">
            {forgotPassword && forgotPassword.to ? (
              <Link
                {...forgotPassword}
                className="text-blueGray-200 ml-2 text-lg"
              >
                <small>Forgot password?</small>
              </Link>
            ) : forgotPassword && forgotPassword.href ? (
              <a {...forgotPassword} className="text-blueGray-200 ml-2 text-lg">
                <small>Forgot password?</small>
              </a>
            ) : null}
          </div>
          <div className="w-1/2 text-right">
            {createAccount && createAccount.to ? (
              <Link
                {...createAccount}
                className="text-blueGray-200 mr-2 text-lg"
              >
                <small>Create new account</small>
              </Link>
            ) : createAccount && createAccount.href ? (
              <a {...createAccount} className="text-blueGray-200 mr-2 text-lg">
                <small>Create new account</small>
              </a>
            ) : null}
          </div>
          <div className="w-full text-right">
            {signIn && signIn.to ? (
              <Link {...signIn} className="text-blueGray-200 mr-2 text-lg">
                <small>Sign in</small>
              </Link>
            ) : signIn && signIn.href ? (
              <a {...signIn} className="text-blueGray-200 mr-2 text-lg">
                <small>Sign in</small>
              </a>
            ) : null}
          </div>
        </div>
      )}
    </>
  );
};

CardLogin.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  // NOTE: the "Forgot password?" text is allready set
  forgotPassword: PropTypes.object,
  // NOTE: the "Create new account" text is allready set
  createAccount: PropTypes.object,
  signIn: PropTypes.object,
  // It is represetnted by the props you
  // can pass to our Button component element
  button: PropTypes.object,
  // It is represetnted by the props you
  // can pass to our Checkbox component element
  checkbox: PropTypes.object,
  inputs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      // It is represetnted by the props you
      // can pass to our Input component element
      // NOTE: if you wish to generate a textarea, you will need to pass
      // // // inside this object >> type: "textarea"
      // // // full example >> input: { type: "textarea" }
      input: PropTypes.object,
    })
  ),
};

export default CardLogin;
